import styled from '@emotion/styled'
import { breakpoint, calcRem, colors, themedValue } from '../../../..'
import { customStyles, getTruncatedCustomCss } from './getCustomCss'

export interface TruncContainerProps {
    mobileFullWidth?: boolean
    /** Custom styles to be applied to truncating container */
    customStyle?: customStyles
}

export const StyledTruncContainer = styled('div')<TruncContainerProps>(
    ({ theme, customStyle }) => {
        return {
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            ...getTruncatedCustomCss(customStyle, theme),
        }
    },
)
interface StyledTruncChildrenProps {
    truncated: boolean
    /** Max height on [xs - Mobile, sm - Tablet, md - Desktop] px unit only*/
    maxHeights: {
        xs: number
        sm: number
        md: number
    }
}

export const StyledChildrenContainer = styled('div')<StyledTruncChildrenProps>(
    ({ theme, truncated, maxHeights }) => {
        return {
            margin: 0,
            padding: 0,
            overflow: 'hidden',
            maxHeight: truncated ? maxHeights.xs : '',

            [breakpoint('sm')]: {
                maxHeight: truncated ? maxHeights.sm : '',
            },

            [breakpoint('md')]: {
                maxHeight: truncated ? maxHeights.md : '',
            },
        }
    },
)

export const StyledButtonContainer = styled('div')<{
    isVisible: boolean
    truncated: boolean
    customStyle?: customStyles
}>(({ theme, isVisible, truncated, customStyle }) => {
    let backgroundColor: string
    switch (customStyle) {
        case 'milestones':
            backgroundColor = colors.thewest.greyErmine
            break
        case 'pinned-post':
        default:
            backgroundColor = theme.colors.palette.white
            break
    }
    let backgroundColorSevenNews: string
    switch (customStyle) {
        case 'milestones':
            backgroundColorSevenNews = truncated
                ? colors.sevennews.greyErmine
                : colors.sevennews.white
            break
        case 'pinned-post':
        default:
            backgroundColorSevenNews = truncated
                ? `linear-gradient(to top, ${colors.sevennews.gray98}, ${colors.sevennews.white})`
                : colors.sevennews.gray98
            break
    }
    return {
        display: isVisible ? 'block' : 'none',

        background: themedValue(theme, {
            sevennews: backgroundColorSevenNews,
            fallback: backgroundColor,
        }),
        padding: theme.margins.md,
        position: 'relative',

        '&::before': {
            background: `linear-gradient(transparent, ${backgroundColor})`,
            display: truncated ? 'block' : 'none',
            position: 'absolute',
            height: '120px',
            margin: 'auto',
            content: `''`,
            left: '0px',
            right: '0px',
            top: '-120px',
            pointerEvents: 'none',
            zIndex: 12,
        },
    }
})

export const StyledShowMoreButton = styled('button')(({ theme }) => ({
    display: 'flex',
    position: 'relative',
    height: calcRem(32),
    minWidth: calcRem(100),
    cursor: 'pointer',
    border: `1px solid ${theme.colors.brand}`,
    borderRadius: calcRem(2),

    zIndex: 13,
    alignItems: 'center',
    justifyContent: 'center',

    color: theme.colors.brand,
    backgroundColor: 'transparent',
    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(13),
    fontWeight: 700,

    /* Increase size of +/- symbol  */
    '& > span::first-letter': {
        fontSize: calcRem(16),
    },

    '&:after': {
        display: 'none',
        border: `1px solid ${theme.colors.palette.black}`,
        content: `''`,
        position: 'absolute',
        top: -3,
        left: -3,
        width: 'calc(100% + 6px)',
        height: 'calc(100% + 6px)',
        borderRadius: calcRem(4),
    },

    '&:hover': {
        backgroundColor: `rgba(4, 61, 226, 0.04)`,
    },

    '&:focus': {
        outline: 'none',

        '&:after': {
            display: 'block',
        },
    },
}))
